<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
    >
      <v-card v-if="dialog">
        <v-card-title>
          <span class="text-h5">{{ title }}</span>
          <v-spacer />
          <v-btn icon @click="close()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <small v-if="error" style="color: red">Fehler beim Erstellen der Rolle</small>
            <v-form v-model="valid" ref="form">
              <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="newRole.roleTitle"
                  label="Rollentitle*"
                  :rules="rules.required"
                ></v-text-field>
              </v-col>
              <!-- <v-col v-for="permission in permissions" :key="permission">
                <v-checkbox
                  :label="permission"
                  v-model="newRole.permissions[permission]"
                  color="secondary"
                ></v-checkbox>
              </v-col> -->
            </v-row>
            </v-form>
          </v-container>
          <small>*zeigt benötigte Felder an</small>
        </v-card-text>
        <v-card-actions>
          <v-btn id="leftButton" text @click="close()">Abbrechen</v-btn>
          <v-btn
            id="rightButton"
            color="primary"
            @click="submitRole()"
          >
            Rolle anlegen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import roleService from "@/pages/UserManagement/roleService"
import permissionService from "@/components/permissionService";
  export default {
    data: () => ({
      dialog: false,
      resolve: null,
      reject: null,
      title: "Neue Rolle anlegen",
      rules: {
        required: [value => !!value || "Muss ausgefüllt werden"]
      },
      newRole: {
        roleTitle: null,
        permissions:[]
      },
      error: false,
      valid: true,
      permissions: []
    }),
    methods:{
      resetData(){
        this.newRole = {
          roleTitle: null,
          permissions:[]
        }
        this.setDefaultPermissions();
        this.error = false;
      },
      open() {
        this.setDefaultPermissions();
        permissionService.retrievePossiblePermissions().then((res) => {
          this.permissions = res.data;
          this.dialog = true;
        });
        return new Promise((resolve, reject) => {
          this.resolve = resolve;
          this.reject = reject;
        });
      },
      submitRole() {
        if(this.$refs.form.validate()){
            this.setDefaultPermissions();
            roleService.addRole(this.newRole.roleTitle).then(() => {
              this.resolve();
              this.resetData();
              this.dialog = false;
            });
        }
      },
      setDefaultPermissions(){
        this.newRole.permissions = {
          READ: true,
          WRITE: false,
          UPDATE: false,
          DELETE: false
        }
      },
      close(){
        this.reject();
        this.resetData();
        this.dialog = false;
      }
    }
  }
</script>